export class WebhookV1CreditsMonthlyUsageNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalCredits",
            "baseName": "totalCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "expectedMonthlyCredits",
            "baseName": "expectedMonthlyCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "actualMonthlyCredits",
            "baseName": "actualMonthlyCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "contractMonths",
            "baseName": "contractMonths",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "agreementId",
            "baseName": "agreementId",
            "type": "string",
            "format": ""
        },
        {
            "name": "thresholdPercentage",
            "baseName": "thresholdPercentage",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1CreditsMonthlyUsageNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
